/**
 * Public studio metrics. Only commitments we control belong here — historical
 * counts (projects delivered, clients, headcount) are claims a prospect cannot
 * verify, so they are surfaced through the real portfolio instead.
 */
export const STUDIO_PUBLIC_STATS = {
  averageResponseHours: 24,
} as const;
